import { PageHeader } from "@/components/shared/PageHeader"
import { useTranslation } from "react-i18next";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Link, useLocation } from "react-router-dom";
import { Settings2 } from "lucide-react";
import { General } from "./pages/General/General";
import FeatureTogglePage from "./pages/FeatureToggle/FeatureTogglePage";

// Константи для табів
const TABS = {
    GENERAL: "general",
    FEATURE_TOGGLES: "feature-toggles"
};

// Визначення табів
const SYSTEM_TABS = [
    { id: TABS.GENERAL, path: "/general", translationKey: "systemSettings.tabs.general" },
    { id: TABS.FEATURE_TOGGLES, path: "/feature-toggles", translationKey: "systemSettings.tabs.featureToggles" }
];

export const SystemSettings = () => {
    const { t } = useTranslation();
    const location = useLocation();

    // Визначаємо активний таб на основі поточного URL
    const currentPath = location.pathname;
    const activeTab = currentPath.includes("/feature-toggles")
        ? TABS.FEATURE_TOGGLES
        : TABS.GENERAL;

    // Рендеринг активного компоненту
    const renderActiveTab = () => {
        switch (activeTab) {
            case TABS.GENERAL:
                return <General />;
            case TABS.FEATURE_TOGGLES:
                return <FeatureTogglePage />;
            default:
                return <General />;
        }
    };

    return (
        <div className="space-y-8 p-8">
            <div className="flex items-center justify-between">
                <PageHeader
                    title={t('systemSettings.title')}
                    icon={<Settings2 />}
                    description={t('systemSettings.description')}
                />
            </div>

            <Tabs value={activeTab} className="w-full">
                <TabsList>
                    {SYSTEM_TABS.map((tab) => (
                        <Link key={tab.id} to={`/home/system-settings${tab.path}`}>
                            <TabsTrigger value={tab.id} className="cursor-pointer">
                                {t(tab.translationKey)}
                            </TabsTrigger>
                        </Link>
                    ))}
                </TabsList>

                <div className="mt-4">
                    {renderActiveTab()}
                </div>
            </Tabs>
        </div>
    );
};
